import { a as __makeTemplateObject, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { rankWith, isBooleanControl } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import styled from 'styled-components';
import { C as CheckBox } from './CheckBox-9e58ea4a.js';
import { S as SimpleMarkdown } from './SimpleMarkdown-107c346a.js';
import { I as InfoTooltip } from './InfoTooltip-cfc025eb.js';

var JsonFormsBooleanControlBase = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  ", "\n"], ["\n  display: flex;\n\n  ", "\n"])), function (_a) {
    var align = _a.align;
    switch (align) {
        case 'center':
            return 'justify-content: center';
        case 'leftWithIcons':
            return 'margin: 0 0 0 40px';
        case 'left':
        default:
            return 'margin: 0';
    }
});
var templateObject_1;

var jsonFormsBooleanControlTester = rankWith(3, isBooleanControl);
/**
 * Boolean Control to be used as a renderer in the `JsonForms` component.
 *
 * @example
 *
 * <JsonForms
 *   renderers={[
 *     {
 *       renderer: JsonFormsBooleanControl,
 *       tester: jsonFormsBooleanControlTester,
 *     },
 *   ]}
 * ></JsonForms>
 */
var JsonFormsBooleanControl = withJsonFormsControlProps(function (_a) {
    var _b, _c;
    var data = _a.data, enabled = _a.enabled, handleChange = _a.handleChange, label = _a.label, path = _a.path, uischema = _a.uischema, visible = _a.visible;
    if (!visible) {
        return null;
    }
    var tooltip = (_b = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _b === void 0 ? void 0 : _b.tooltip;
    var align = (_c = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _c === void 0 ? void 0 : _c.align;
    return (jsxs(JsonFormsBooleanControlBase, __assign({ align: align }, { children: [jsx(CheckBox, __assign({ checked: data, disabled: !enabled, onChange: function (event) {
                    var checked = event.currentTarget.checked;
                    handleChange(path, checked);
                } }, { children: typeof label === 'string' ? (jsx(SimpleMarkdown, { children: label }, void 0)) : null }), void 0), tooltip && (jsx(InfoTooltip, { children: jsx(SimpleMarkdown, { children: tooltip }, void 0) }, void 0))] }), void 0));
});

export { JsonFormsBooleanControl as J, jsonFormsBooleanControlTester as j };
